import PropTypes from 'prop-types'
import { useState } from 'react'
import Navbar from './Navbar/Navbar'
import Sidebar from './Sidebar/Sidebar'

export default function Layout({ children }) {
  // Estado que indica si la barra lateral está abierta o cerrada
  const [isSidebarOpen, setIsSidebarOpen] = useState(false)

  return (
    <>
      <div className="fixed w-screen h-screen">
        <Sidebar
          isSidebarOpen={isSidebarOpen}
          setIsSidebarOpen={setIsSidebarOpen}
        />

        <div className="fixed flex flex-col w-full h-full bg-[#F3F4F6] dark:bg-[#2E2F33] duration-100">
          <Navbar
            isSidebarOpen={isSidebarOpen}
            setIsSidebarOpen={setIsSidebarOpen}
          />

          <div className="fixed z-40 flex flex-col w-full h-full pt-20 grow">
            <div
              id="scrollable-parent"
              className={`relative w-full p-4 duration-100 overflow-y-auto overflow-x-hidden grow ${isSidebarOpen ? 'md:pl-64' : 'md:pl-24'}`}
            >
              {children}
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

// Define los tipos de las props que recibe el componente actual
Layout.propTypes = {
  children: PropTypes.node.isRequired
}
